// ** MUI Imports
import Box from '@mui/material/Box'
import IconButton from '@mui/material/IconButton'

// ** Icon Imports
import Icon from 'src/@core/components/icon'

// ** Components
import ModeToggler from 'src/@core/layouts/components/shared-components/ModeToggler'
import LinksDropdown from 'src/@core/layouts/components/shared-components/LinksDropdown'
import Clock from 'src/utils/Clock'

// ** Hook Import
import { useRouter } from 'next/router'

/*
  Se quitaron Autocomplete, ShortcutsDropdown, NotificationDropdown y UserDropdown,
  junto con los arrays de notificaciones y atajos del template.

  Los cuatro colgaban de `auth.user`, que en este sitio es siempre null: no hay
  ruta de login (vive en src/_template-demos/) y `authConfig.meEndpoint` no existe
  bajo `output: 'export'`. O sea que nunca se renderizaban, pero si viajaban en el
  chunk compartido _app y en su costo de parseo. Sus atajos apuntaban ademas a
  rutas demo que ya no estan publicadas.

  El <Clock> se renderiza normalmente (antes iba con dynamic ssr:false). Ver el
  comentario en src/utils/Clock.js: era el origen del CLS de la home.
*/

const AppBarContent = props => {
  // ** Props
  const { settings, saveSettings, toggleNavVisibility } = props

  // ** Hook
  const router = useRouter()

  const handleDashboard = () => {
    router.push('/dashboard')
  }

  return (
    <Box sx={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
      <Box className='actions-left' sx={{ mr: 2, display: 'flex', alignItems: 'center' }}>
        {/*
          El hamburguesa se muestra u oculta por CSS, no por `hidden`.

          Con `hidden` (useMediaQuery) no existia en el HTML estatico y aparecia
          recien al hidratar, lo que ensanchaba actions-left y movia la barra.
          Con breakpoints es el mismo marcado en servidor y cliente: visible por
          debajo de lg, oculto de lg para arriba, sin reflow.
        */}
        {settings.navHidden ? null : (
          <IconButton
            color='inherit'
            sx={{ ml: -2.75, display: { xs: 'inline-flex', lg: 'none' } }}
            onClick={toggleNavVisibility}
            aria-label='Open navigation menu'
          >
            <Icon icon='mdi:menu' />
          </IconButton>
        )}
      </Box>
      <Box className='actions-right' sx={{ display: 'flex', alignItems: 'center' }}>
        <Box>
          <Clock />
          <Clock type='local' />
        </Box>
        <IconButton color='inherit' onClick={handleDashboard} aria-label='Go to dashboard'>
          <Icon icon='ic:round-dashboard' />
        </IconButton>
        <LinksDropdown />
        <ModeToggler settings={settings} saveSettings={saveSettings} />
      </Box>
    </Box>
  )
}

export default AppBarContent
